module.exports = __webpack_public_path__ + "media/assets/images/events/20210610_offcar/mkithp_sharing_hero_image_offcar-b8f52bc3eb22f8d51dfa6ebe75096cdf.jpg";